import React from "react";
import {AdminProvider} from "context/AdminContext";

const Provider = ({children}) => {
    return (
        <AdminProvider>
            
                    {children}
         
        </AdminProvider>
    )
}
export default Provider;
